<template>
	<div class="AddTestQuestions">
		<div class="page-header"><el-page-header @back="goBack" :content="`${$t('QuesLibrary.TestQuestionManagement')} - ${$t('QuesLibrary.EditItem')}`"></el-page-header></div>
		<div class="body"><Questionstype :isBank="true" :paperObj="paper" @submit="submit"></Questionstype></div>
	</div>
</template>

<script>
import { mapState } from 'vuex';
import Questionstype from '@/page/myQuestionnaire/QuestionstypeCopyDelLeft.vue';
import Paper from '@/page/myQuestionnaire/js/Paper.js';
export default {
	name: 'AddTestQuestions',
	components: {
		Questionstype
	},
	props: {
		bankId: {
			type: String,
			default: ''
		}
	},
	data() {
		return {
			collapseVisible: ['1', '2', '3', '4'],
			
			paper: {},
			operationTimer: '',
			countDown: 60,
			createTime: ''
		};
	},
	computed: {
		...mapState(['examQuestionTypeArr']),
		id() {
			return this.$route.query.bankId;
		},
		title() {
			return this.$route.query.title;
		},
		depict() {
			return this.$route.query.depict;
		},
		isEdit() {
			return this.$route.query.isEdit;
		},
		questionsId() {
			return this.$route.query.questionsId;
		}
	},
	created() {
		// console.log(`题库id: ${this.id}`)
		// 初始化paper
		this.initFunction();
		if (this.isEdit) {
			// 加载试题
			this.getQuestion();
		}
	},
	mounted() {
		// 获取创建时间
		this.createTime = this.$functions.GetDate();
	},
	methods: {
		getQuestion() {
			let that = this;
			let data = {
				id: this.id
			};
			let params = {
				that: this,
				url: `${this.$config.service.examBankGetQuess}?id=${this.id}`,
				method: 'GET',
				cb(res) {
					if (res.code == '0') {
						let paperjson = JSON.parse(res.resultBody.paperjson);
						paperjson.questionsListCopy = JSON.parse(JSON.stringify(paperjson.questionsList));
						let newlist = [];
						// console.log('paperjson.questionsList :>> ', paperjson.questionsList);
						paperjson.questionsList.forEach((item, index) => {
							if (that.$functions.isJSON(item)) {
								item = JSON.parse(item)
							}
							// console.log('111111111111111', item.qid, that.questionsId);
							if (item.qid) {
								if (item.qid == that.questionsId) {
									console.log('111111111111111');
									newlist.push(item);
								}
							}
						});
						paperjson.questionsList = newlist;
						console.log(paperjson.questionsList);
						let paper = paperjson;
						for (let key in paper) {
							that.paper[key] = paper[key];
						}
						that.paper.questionsList = paperjson.questionsList.map(info => {
							if (that.$functions.isJSON(info)) {
								return JSON.parse(info);
							}
							return info;
						});
					}
				}
			};
			this.$util.request(params);
		},
		submit(state) {
			let paperJson = JSON.parse(JSON.stringify(this.paper));
			// console.log(paperJson.questionsListCopy)
			// console.log(paperJson.questionsList)
			// if(paperJson.questionsListCopy){
			// 	paperJson.questionsList.forEach(item=>{
			// 		paperJson.questionsListCopy.forEach((item2,index2)=>{
			// 			if(item.qid==item2.qid){
			// 				console.log(item2,item)
			// 				// item2 = JSON.parse(JSON.stringify(item));
			// 				paperJson.questionsListCopy.splice(index2,1,JSON.parse(JSON.stringify(item)))
			// 			}
			// 		})
			// 	})
			// 	paperJson.questionsList = paperJson.questionsListCopy
			// 	delete paperJson.questionsListCopy
			// }
			let that = this;
			console.log(paperJson);
			// return false
			let data = {
				id: this.questionsId,
				bid: this.id,
				quesJson: JSON.stringify(paperJson.questionsList[0])
				// createTime: this.createTime,
				// updateTime: this.$functions.GetDate(),
				// bankType: 1
			};
			let params = {
				that: this,
				url: `${this.$config.service.updateQues}`,
				method: 'post',
				data: data,
				cb(res) {
					if (res.code == '0') {
						console.log();
						if (state) {
							that.goBack();
							that.$message({
								message: that.$t('QuesLibrary.Success'),
								type: 'success'
							});
						}
					} else {
						that.$message.error(res.message);
					}
				}
			};
			this.$util.request(params);
		},
		initFunction() {
			//默认创建对象
			this.paper = new Paper();
			this.paper.title = this.title;
			this.paper.depict = this.depict;
		},
		goBack() {
			this.$router.go(-1);
		}
	},
	beforeRouteLeave(to, from, next) {
		// console.log('路由跳转')
		// this.submit();
		clearTimeout(this.operationTimer);
		next();
	}
};
</script>

<style lang="scss" scoped>
.AddTestQuestions {
	height: 100%;
	background-color: #fff !important;
	.page-header {
		padding: 20px;
		background-color: rgb(255, 255, 255);
	}
	.form-box {
		width: 600px;
		margin: 40px auto 0 auto;
		.title {
			font-size: 16px;
			margin: 0 0 40px 30px;
		}
	}
	.body {
	}
}
</style>
